<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    :class="['app-btn', `app-btn--${variant}`]"
    :style="btnStyle"
    @click="$emit('click', $event)"
  >
    <slot />
    <span v-if="arrow" class="arrow">→</span>
  </component>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'outline', 'soft', 'link', 'white'].includes(v)
    },
    to: { type: [String, Object], default: '' },
    arrow: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    size: { type: String, default: '' }
  },
  computed: {
    btnStyle() {
      const s = {};
      if (this.block) s.display = 'flex';
      return s;
    }
  }
};
</script>

<style lang="less" scoped>
.app-btn {
  border: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border-radius: 999px;
  font-weight: 700;
  transition: 0.25s;
  text-decoration: none;
  line-height: 1;
  white-space: nowrap;

  &--primary {
    background: linear-gradient(110deg, #ffe08b, #ffc84e);
    color: #07101d;
    box-shadow: 0 12px 34px rgba(255, 203, 78, 0.2);
    padding: 14px 25px;
    &:hover {
      transform: translateY(-2px);
      filter: brightness(1.04);
      box-shadow: 0 18px 44px rgba(255, 203, 78, 0.28);
    }
  }
  &--outline {
    padding: 13px 24px;
    border: 1px solid rgba(255, 255, 255, 0.22);
    background: rgba(255, 255, 255, 0.04);
    color: #fff;
    &:hover {
      background: rgba(255, 255, 255, 0.09);
      border-color: rgba(255, 255, 255, 0.38);
      transform: translateY(-2px);
    }
  }
  &--soft {
    padding: 12px 19px;
    background: rgba(78, 182, 255, 0.11);
    border: 1px solid rgba(78, 182, 255, 0.22);
    color: #bcecff;
    &:hover {
      background: rgba(78, 182, 255, 0.18);
      transform: translateY(-2px);
    }
  }
  &--link {
    background: none;
    color: #86dcff;
    padding: 8px 0;
    &:hover {
      color: #fff;
    }
  }
  &--white {
    background: #fff;
    color: #07101d;
    padding: 13px 24px;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 34px rgba(255, 255, 255, 0.2);
    }
  }

  .arrow {
    display: inline-block;
    transition: 0.2s;
  }
  &:hover .arrow {
    transform: translateX(4px);
  }
}
</style>
